
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seguro-santander-auto",
      function () {
        return require("private-next-pages/seguro-santander-auto.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seguro-santander-auto"])
      });
    }
  